import { NgModule, ModuleWithProviders, Inject, Optional, InjectionToken, SkipSelf } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { OpenPanelEventDirective } from './open-panel-event.directive';
import { OpenPanelService } from '@app/shared/misc/analytics/open-panel.service';

export const OPENPANEL_ROOT_GUARD = new InjectionToken('OPENPANEL_ROOT_GUARD');
export function provideForRootGuard(analytics: AnalyticsService): any {
  if (analytics) {
    throw new Error(`Analytics Module.forRoot() called twice. Lazy loaded modules should use forChild().`);
  }
  return 'guarded';
}

@NgModule({
  declarations: [OpenPanelEventDirective],
  exports: [OpenPanelEventDirective],
})
export class OpenPanelModule {
  static forRoot(): ModuleWithProviders<OpenPanelModule> {
    return {
      ngModule: OpenPanelModule,
      providers: [
        {
          provide: OPENPANEL_ROOT_GUARD,
          useFactory: provideForRootGuard,
          deps: [[AnalyticsService, new Optional(), new SkipSelf()]],
        },
        AnalyticsService,
        OpenPanelService,
      ],
    };
  }

  static forChild(): ModuleWithProviders<OpenPanelModule> {
    return {
      ngModule: OpenPanelModule,
      providers: [],
    };
  }
  constructor(@Optional() @Inject(OPENPANEL_ROOT_GUARD) guard: any) {}
}
